<template>
  <div>
    <fieldset
      v-if="
        ownerInfo.ownerId ||
        ownerInfo.ownerContact ||
        ownerInfo.ownerFullAddress ||
        ownerInfo.ownerDetail
      "
    >
      <legend><h3 style="color: #0f4b90">Owner Details</h3></legend>
      <div style="padding: 10px" v-if="ownerInfo.ownerId">
        <b>Owner #: </b>
        {{ ownerInfo.ownerId }}
      </div>
      <div style="padding: 10px" v-if="ownerInfo.ownerContact">
        <b>Owner Name: </b>
        {{ ownerInfo.ownerContact }}
      </div>
      <div style="padding: 10px" v-if="ownerInfo.ownerFullAddress">
        <b>Owner Address: </b>
        {{ ownerInfo.ownerFullAddress }}
      </div>
      <div style="padding: 10px" v-if="ownerInfo.ownerDetail">
        <b>Owner Details: </b>
        {{ ownerInfo.ownerDetail }}
      </div>
    </fieldset>

    <fieldset v-if="activeSites">
      <legend><h3 style="color: #0f4b90">Sites</h3></legend>
      <div
        v-for="(site, index) in activeSites"
        :key="index"
        style="margin: 10px"
      >
        <div style="padding: 10px">
          <div
            style="
              display: flex;
              justify-content: space-between;
              background: #0f4b90;
            "
          >
            <div style="padding: 10px; padding-bottom: 10px; color: white">
              <span style="margin: 0px 3px 0px 0px">Site Id: </span>
              {{ site.site_Id }}
            </div>
            <div
              style="padding: 10px; color: white"
              v-if="ownerInfo.ownerContact"
            >
              <span style="margin: 0px 3px 0px 0px">Site Name: </span>
              {{ site.site_Name }}
            </div>
            <div
              style="padding: 10px; padding-bottom: 10px; color: white"
              v-if="ownerInfo.ownerFullAddress"
            >
              <span style="margin: 0px 3px 0px 0px">Site Address: </span>
              {{ site.site_Address }}
            </div>
          </div>
          <div style="margin-top: 5px" class="e-card">
            <div class="e-card-content">
              <ejs-grid
                :dataSource="site.tanks"
                ref="refTankInfo"
                :allowSorting="true"
                :allowPaging="true"
                :pageSettings="pageSettings"
                :toolbar="toolbarOptions"
                :allowTextWrap="true"
                height="100%"
                width="100%"
              >
                <e-columns>
                  <e-column
                    field="tank_Id"
                    headerText="Tank Id"
                    textAlign="Left"
                  />
                  <e-column
                    field="tank_Type"
                    headerText="Tank Type"
                    textAlign="Left"
                  />
                  <e-column
                    field="tank_Serial_No"
                    headerText="Tank Serial#"
                    textAlign="Left"
                  />
                </e-columns>
              </ejs-grid>
            </div>
          </div>
          <fieldset v-if="getSiteComments(site.site_Id)">
            <legend><h3 style="color: #0f4b90">Site Comments</h3></legend>
            <b>{{ getSiteComments(site.site_Id) }}</b>
          </fieldset>
        </div>
      </div>
    </fieldset>

    <fieldset v-if="getSiteComments(null)">
      <legend><h3 style="color: #0f4b90">Summary of Comments</h3></legend>
      <b>{{ getSiteComments(null) }}</b>
    </fieldset>
    <div style="margin-top: 5px;" class="e-card">
      <div class="e-card-title">Uploaded Documents</div>
      <div class="e-card-separator"></div>
      <div class="e-card-content">
        <div style="display: flex; justify-content: end"></div>
        <ejs-grid
          ref="documentsGrid"
          :dataSource="documentsDS"
          :toolbar="toolbarOptions"
          height="50%"
          :allowSorting="true"
          :allowExcelExport="false"
          :allowPaging="true"
          :pageSettings="pageSettings"
          :allowTextWrap="true"
        >
          <e-columns>
            <e-column
              field="documentName"
              width="400"
              headerText="Document Name"
            />
            <e-column
              headerText="Date Uploaded"
              type="date"
              format="dd/MM/yyyy"
              field="createDate"
            />
            <e-column headerText="Uploaded By" field="createUser" />
          </e-columns>
        </ejs-grid>
      </div>
    </div>
    <div style="margin-left: 50%; margin-top: 10px">
      <button
        @click="onBackButtonClick"
        class="e-control e-btn e-lib e-primary"
      >
        Back
      </button>
      <button @click="submitButtonClick" class="e-control e-btn e-lib e-info">
        Submit For review
      </button>
    </div>
  </div>
</template>

<script>
import { DialogUtility } from '@syncfusion/ej2-popups';
import { mapGetters } from 'vuex';
import { submitReviewData } from '../services/site-eservices-api';

let DialogObj;

export default {
  name: 'SiteReview',
  props: {
    comments: Array,
    documentsDS: {
      type: Array,
      default() {
        return null;
      },
    },
    ownerInfo: Object,
  },
  data() {
    return {
      toolbarOptions: ['Search'],
      pageSettings: { pageSize: 10 },
    };
  },
  watch: {
    documentsDS() {
      this.$refs.documentsGrid.refresh();
    },
  },
  computed: {
    ...mapGetters({
      mySites: 'mySites',
      loggedUser: 'loggedUser',
    }),
    activeSites() {
      if (this.mySites) {
        return this.mySites.filter(
          (x) => x.facility_Status === 'Active',
        );
      }
      return null;
    },
  },
  methods: {
    getSiteComments(siteId) {
      return this.comments.find((x) => x.siteId === siteId)?.comments;
    },
    onBackButtonClick() {
      const tabObj = document.getElementById('collapsible_tab');
      tabObj.ej2_instances[0].select(0);
    },
    submitButtonClick() {
      DialogObj = DialogUtility.confirm({
        title: 'Submit Review',
        content: 'Are you sure you want to submit for review?',
        okButton: { text: 'OK', click: this.submit },
        cancelButton: { text: 'Cancel', click: this.hideDeleteDialog },
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: 'Zoom' },
      });
    },
    hideDeleteDialog() {
      DialogObj.hide();
    },
    notify(type, message) {
      this.$parent.$parent.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === 'Error !' ? 'e-toast-danger' : 'e-toast-success',
        timeOut: 5000,
      });
      if (this.$parent.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$parent.$refs.notifierRef.show();
      }
    },
    async submit() {
      this.hideDeleteDialog();
      try {
        const { ownerId } = this.ownerInfo;
        const { ownerContactId } = this.ownerInfo;
        let requestId= this.$parent.defaultOwner ? this.$parent.defaultOwner.requestId : '';        
        if (!requestId) { requestId = this.$parent.isSiteReviewReadyData ?  this.$parent.isSiteReviewReadyData.applicationRequestId : '' }
        // eslint-disable-next-line max-len
        await submitReviewData(this.loggedUser.email, ownerId, ownerContactId, requestId).then((res) => {
          this.$parent.isSiteReviewReadyData = res.data;
          this.notify('Success !', 'Review submitted Successfully');
        });
        const tabObj = document.getElementById('collapsible_tab');
        tabObj.ej2_instances[0].enableTab(3, false);
        tabObj.ej2_instances[0].select(0);
      } catch (err) {
        this.hideDeleteDialog();
        this.notify('Error !', 'Error occurred while submitting review');
      }
    },
  },
};
</script>
